import {notAuthorizedMessage} from '../services/not-authorized.js';

export default function MemberSearchCtrl($scope, $wamp, $stateParams, progressBar, $state, $anchorScroll) {

  $scope.query = {term: $stateParams.query, query: $stateParams.query};

  $scope.noItems = false;

  progressBar.add('org.eggs.trade_search');
  $wamp.call('org.eggs.trade_search', [$stateParams.query]).then(function (res) {
    // console.log(res);
    $scope.results = res;

    $scope.noItems = res.length < 1;
    progressBar.remove('org.eggs.trade_search');
  }, function (err) {
    progressBar.remove('org.eggs.trade_search');
    // A login the backend won't search for (no trading access): its message in place of results.
    const message = notAuthorizedMessage(err);
    if (!message) {
      console.error(err);
      return;
    }
    $scope.$applyAsync(function () {
      $scope.refused = message;
    });
  });

  if ($state.params.id) {
    $anchorScroll('trade' + $state.params.id);
  }
}
